module.exports = __webpack_public_path__ + "media/images/version_merge/raffle_promotion-main-da99a4b13715646c628a9b5e7ddb7cda.jpg";